import { 
  UsersIcon, 
  TrendingDownIcon, 
  CircleDollarSignIcon, 
  BarChart3Icon,
  GraduationCapIcon,
  TargetIcon,
  ArrowRightIcon,
  FileTextIcon
} from "lucide-react";
import { Link } from "wouter";

export default function OurImpact() {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">Potential Impact</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Justice Reform Through Employment
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-500 lg:mx-auto">
            Our research publications show how the StaffAbility model could transform justice outcomes through skills training, employment, and support.
          </p>
        </div>

        {/* White Paper Feature Box */}
        <div className="mt-12 bg-primary-50 rounded-lg p-8 border border-primary-200 shadow-md">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-2/3">
              <div className="flex items-center mb-4">
                <FileTextIcon className="h-8 w-8 text-primary-600 mr-3" />
                <h3 className="text-2xl font-bold text-primary-800">White Paper & Impact Report 2.0</h3>
                <span className="ml-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800">
                  Updated
                </span>
              </div>
              <p className="text-slate-700 mb-6">
                Our comprehensive white paper and impact report outlines the StaffAbility model for breaking down career barriers
                for justice-involved individuals. This data-driven document details our approach, mission,
                projected outcomes, and implementation strategy for creating meaningful change.
              </p>
              <div>
                <Link to="/research">
                  <button className="bg-indigo-800 hover:bg-indigo-900 text-white font-medium py-2 px-4 rounded-lg flex items-center">
                    View White Paper 
                    <ArrowRightIcon className="ml-2 h-4 w-4" />
                  </button>
                </Link>
                <div className="mt-3">
                  <a href="https://drive.google.com/file/d/1FB4e2OVsvXjox6g4-tFB8YZZledqvrp2/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block">
                    <button className="bg-white hover:bg-primary-50 text-primary-700 border border-primary-300 font-medium py-2 px-4 rounded-lg flex items-center">
                      Download PDF
                      <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div className="md:w-1/3 flex justify-center mt-6 md:mt-0">
              <div className="bg-white p-4 rounded-md shadow-lg border border-primary-200 transform rotate-2 hover:rotate-0 transition-transform w-48 h-60 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-primary-800 font-bold text-lg">StaffAbility</div>
                  <div className="text-primary-600 mb-2 text-sm">White Paper & Impact</div>
                  <div className="w-32 h-24 mx-auto mb-2 bg-primary-100 rounded flex items-center justify-center">
                    <FileTextIcon className="h-12 w-12 text-primary-500" />
                  </div>
                  <div className="text-slate-700 text-xs">
                    Version 2.0
                    <br />2025 Edition
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* NEW Impact Report Feature Box */}
        <div className="mt-12 bg-blue-50 rounded-lg p-8 border border-blue-200 shadow-md">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-2/3">
              <div className="flex items-center mb-4">
                <BarChart3Icon className="h-8 w-8 text-blue-600 mr-3" />
                <h3 className="text-2xl font-bold text-blue-800">Impact & Opportunity Report</h3>
                <span className="ml-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  New
                </span>
              </div>
              <p className="text-slate-700 mb-6">
                Our comprehensive data-driven analysis reveals how StaffAbility's model could transform justice outcomes through employment. 
                Read our newly released report with detailed projections on recidivism reduction, economic benefits, and community impact.
              </p>
              <div>
                <Link to="/impact-report">
                  <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg flex items-center">
                    View Full Report 
                    <ArrowRightIcon className="ml-2 h-4 w-4" />
                  </button>
                </Link>
                <div className="mt-3">
                  <a href="https://drive.google.com/file/d/14f0KAvvUro8OYduO08PXQy8QePHpj21k/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <button className="bg-white hover:bg-blue-50 text-blue-700 border border-blue-300 font-medium py-2 px-4 rounded-lg flex items-center">
                      Download PDF
                      <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div className="md:w-1/3 flex justify-center mt-6 md:mt-0">
              <div className="bg-white p-4 rounded-md shadow-lg border border-blue-200 transform rotate-2 hover:rotate-0 transition-transform w-48 h-60 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-blue-800 font-bold text-lg">StaffAbility</div>
                  <div className="text-blue-600 mb-2 text-sm">Impact & Opportunity</div>
                  <div className="w-32 h-24 mx-auto mb-2 bg-blue-100 rounded flex items-center justify-center">
                    <BarChart3Icon className="h-12 w-12 text-blue-500" />
                  </div>
                  <div className="text-slate-700 text-xs">
                    Data-Driven Analysis
                    <br />2025 Edition
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-primary-50 rounded-lg p-8">
          <h3 className="text-xl font-bold text-primary-800 mb-6">The Current Justice System Challenge</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-br from-red-100 to-red-200 text-red-600 mr-4 shadow-sm">
                  <TrendingDownIcon className="h-5 w-5" />
                </div>
                <p className="text-xl font-semibold text-slate-900">67%</p>
              </div>
              <p className="text-slate-900 font-medium mb-2">Recidivism Rate</p>
              <p className="text-slate-600 text-sm">
                Two-thirds of individuals released from incarceration are rearrested within 3 years, largely due to lack of economic opportunity.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-br from-orange-100 to-orange-200 text-orange-600 mr-4 shadow-sm">
                  <CircleDollarSignIcon className="h-5 w-5" />
                </div>
                <p className="text-xl font-semibold text-slate-900">$182B+</p>
              </div>
              <p className="text-slate-900 font-medium mb-2">Annual Cost</p>
              <p className="text-slate-600 text-sm">
                The U.S. spends over $182 billion annually on incarceration and related expenses, yet outcomes remain poor.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-br from-amber-100 to-amber-200 text-amber-600 mr-4 shadow-sm">
                  <BarChart3Icon className="h-5 w-5" />
                </div>
                <p className="text-xl font-semibold text-slate-900">27%</p>
              </div>
              <p className="text-slate-900 font-medium mb-2">Unemployment Rate</p>
              <p className="text-slate-600 text-sm">
                Formerly incarcerated individuals face unemployment rates 5 times higher than the general population.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12">
          <div className="text-center mb-8">
            <h2 className="text-xl sm:text-2xl font-bold text-primary-800 mb-2">StaffAbility Model: Projected Impact</h2>
            <p className="text-slate-600 max-w-2xl mx-auto">Our ambitious targets will transform lives and create lasting change in the justice system.</p>
          </div>
          
          {/* Impact Stats Cards - Top Row */}
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            {/* Impact Stat 1 - Employment */}
            <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl shadow-md border border-primary-100 transform transition-transform hover:scale-[1.02]">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center h-14 w-14 rounded-full bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 text-white shadow-md">
                  <TargetIcon className="h-7 w-7" />
                </div>
                <div className="ml-5">
                  <p className="text-4xl font-bold text-primary-600">100%</p>
                  <p className="text-lg font-medium text-slate-800">Target Employment</p>
                </div>
              </div>
              <p className="text-slate-600">
                Our mission: 100% employment for all program participants through comprehensive training and employer partnerships. <a href="https://drive.google.com/file/d/1FB4e2OVsvXjox6g4-tFB8YZZledqvrp2/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-800 font-medium">Learn more →</a>
              </p>
            </div>

            {/* Impact Stat 2 - Recidivism */}
            <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl shadow-md border border-primary-100 transform transition-transform hover:scale-[1.02]">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center h-14 w-14 rounded-full bg-gradient-to-r from-red-500 to-rose-600 text-white shadow-md">
                  <TrendingDownIcon className="h-7 w-7" />
                </div>
                <div className="ml-5">
                  <p className="text-4xl font-bold text-primary-600">100%</p>
                  <p className="text-lg font-medium text-slate-800">Recidivism Elimination</p>
                </div>
              </div>
              <p className="text-slate-600">
                Our goal is to completely eliminate recidivism through our integrated approach to employment, support, and community integration. <a href="https://drive.google.com/file/d/1FB4e2OVsvXjox6g4-tFB8YZZledqvrp2/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-800 font-medium">Learn more →</a>
              </p>
            </div>
          </div>
          
          {/* Impact Stats Cards - Bottom Row */}
          <div className="grid md:grid-cols-2 gap-6">
            {/* Impact Stat 3 - Support Period */}
            <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl shadow-md border border-primary-100 transform transition-transform hover:scale-[1.02]">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center h-14 w-14 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-md">
                  <UsersIcon className="h-7 w-7" />
                </div>
                <div className="ml-5">
                  <p className="text-4xl font-bold text-primary-600">24mo</p>
                  <p className="text-lg font-medium text-slate-800">Support Period</p>
                </div>
              </div>
              <p className="text-slate-600">
                Our 24-month intensive support model provides wrap-around services and personalized career development for lasting success.
              </p>
            </div>

            {/* Impact Stat 4 - ROI */}
            <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl shadow-md border border-primary-100 transform transition-transform hover:scale-[1.02]">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center h-14 w-14 rounded-full bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-md">
                  <CircleDollarSignIcon className="h-7 w-7" />
                </div>
                <div className="ml-5">
                  <p className="text-4xl font-bold text-primary-600">12.5x</p>
                  <p className="text-lg font-medium text-slate-800">ROI Over 2 Years</p>
                </div>
              </div>
              <p className="text-slate-600">
                For every dollar invested in StaffAbility, society receives a 12.5x return through reduced incarceration costs and increased workforce productivity. <a href="https://drive.google.com/file/d/1FB4e2OVsvXjox6g4-tFB8YZZledqvrp2/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-800 font-medium">See the business case →</a>
              </p>
            </div>
          </div>
        </div>

        {/* Impact Sims Section */}
        <div className="mt-16 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-8 shadow-xl border border-indigo-200">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-indigo-800 mb-2">Impact Sims</h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Explore the real economic impact of second-chance employment programs in your city with our interactive simulation tool.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-2/3 mb-6 md:mb-0">
              <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="bg-white p-4 rounded-lg shadow-md text-center">
                  <div className="text-2xl font-bold text-indigo-600">81%</div>
                  <div className="text-sm text-slate-600">Recidivism Reduction</div>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-md text-center">
                  <div className="text-2xl font-bold text-green-600">$65M+</div>
                  <div className="text-sm text-slate-600">Cost Savings</div>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-md text-center">
                  <div className="text-2xl font-bold text-purple-600">1,300%</div>
                  <div className="text-sm text-slate-600">ROI</div>
                </div>
              </div>
              <p className="text-slate-700 mb-6">
                See how StaffAbility's evidence-based programs can transform justice outcomes in your community. 
                Our audit-ready calculator shows real economic benefits from reducing recidivism through employment support.
              </p>
              <Link to="/economic-impact-simulator">
                <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-6 rounded-lg flex items-center text-lg">
                  Try Impact Sims
                  <ArrowRightIcon className="ml-2 h-5 w-5" />
                </button>
              </Link>
            </div>
            <div className="md:w-1/3 flex justify-center">
              <div className="bg-white p-6 rounded-xl shadow-lg border border-indigo-200 transform hover:scale-105 transition-transform">
                <div className="text-center">
                  <div className="flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white mx-auto mb-4">
                    <BarChart3Icon className="h-8 w-8" />
                  </div>
                  <div className="text-indigo-800 font-bold text-lg mb-2">Economic Impact</div>
                  <div className="text-indigo-600 text-sm mb-3">Simulation Tool</div>
                  <div className="text-slate-600 text-xs">
                    Interactive calculator for<br />
                    policy decision makers
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-16 bg-primary-100 rounded-xl p-8 shadow-xl border border-primary-300">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-primary-800 mb-2">Proposed Impact by 2030</h2>
            <p className="text-slate-600 max-w-2xl mx-auto">Our long-term vision will create significant societal and economic transformation.</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg border border-primary-200 transform transition-transform hover:scale-[1.02]">
              <div className="flex items-center gap-5 mb-6">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 text-white shadow-lg">
                  <GraduationCapIcon className="h-8 w-8" />
                </div>
                <div>
                  <p className="text-5xl font-bold text-primary-700">50,000<span className="text-primary-500">+</span></p>
                  <p className="text-xl font-medium text-slate-700">Program Graduates</p>
                </div>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-300 text-slate-700">
                <p>
                  Transforming the lives of over 50,000 justice-involved individuals through targeted skills training and meaningful career placement. <a href="https://drive.google.com/file/d/1FB4e2OVsvXjox6g4-tFB8YZZledqvrp2/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-800 font-medium">View program details →</a>
                </p>
              </div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-lg border border-primary-200 transform transition-transform hover:scale-[1.02]">
              <div className="flex items-center gap-5 mb-6">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-green-500 via-green-600 to-green-700 text-white shadow-lg">
                  <CircleDollarSignIcon className="h-8 w-8" />
                </div>
                <div>
                  <p className="text-5xl font-bold text-primary-700">$720<span className="text-primary-500">M</span></p>
                  <p className="text-xl font-medium text-slate-700">Economic Impact</p>
                </div>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-300 text-slate-700">
                <p>
                  Generating $720 million in economic value through reduced justice system costs and increased workforce contributions. <a href="https://drive.google.com/file/d/1FB4e2OVsvXjox6g4-tFB8YZZledqvrp2/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-800 font-medium">See economic analysis →</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
